import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import { commands as audioCommands } from '@cdo/apps/lib/util/audioApi';
import { getFilteredSongKeys } from '@cdo/apps/dance/songs';
import Button from '@cdo/apps/templates/Button';
import moduleStyles from '@cdo/apps/dance/song-selector.module.scss';
var commonI18n = require('@cdo/locale');
var currentTimeoutsMap = {};
var songPreviewDurationInMs = 10000;
var SongSelector = function (_a) {
    var selectedSong = _a.selectedSong, levelIsRunning = _a.levelIsRunning, setSong = _a.setSong, songData = _a.songData, enableSongSelection = _a.enableSongSelection, filterOn = _a.filterOn;
    var _b = useState(false), songInPreview = _b[0], setSongInPreview = _b[1];
    var onPreviewBtnClick = useCallback(function () {
        if (songInPreview) {
            audioCommands.stopSound({ url: songData[selectedSong].url });
        }
        else {
            audioCommands.playSound({
                url: "".concat(songData[selectedSong].url),
                callback: function () {
                    setSongInPreview(true);
                    var timeoutID = setTimeout(function () {
                        if (!levelIsRunning) {
                            audioCommands.stopSound({ url: songData[selectedSong].url });
                        }
                    }, songPreviewDurationInMs);
                    currentTimeoutsMap[selectedSong] = timeoutID;
                },
                onEnded: function () {
                    currentTimeoutsMap[selectedSong] &&
                        clearTimeout(currentTimeoutsMap[selectedSong]);
                    delete currentTimeoutsMap[selectedSong];
                    setSongInPreview(false);
                },
            });
        }
    }, [levelIsRunning, selectedSong, songData, songInPreview]);
    var songKeys = getFilteredSongKeys(songData, filterOn);
    // When you change the song - unloadSong is triggered in apps/src/dance/songs.js. (which unloads and stops the current song)
    // When song is stopped - audioCommands.playSound onEnded callback is triggered where we set setSongInPreview(false).
    var changeSong = useCallback(function (event) {
        var songId = event.target.value;
        setSong(songId);
    }, [setSong]);
    return (React.createElement("div", { id: "song-selector-wrapper", className: moduleStyles.songSelectorWrapper },
        React.createElement("label", null,
            React.createElement("b", null, commonI18n.selectSong())),
        React.createElement("select", { id: "song_selector", className: moduleStyles.selectStyle, onChange: changeSong, value: selectedSong, disabled: !enableSongSelection }, songKeys.map(function (option, i) { return (React.createElement("option", { key: i, value: option }, songData[option].title)); })),
        React.createElement(Button, { type: "button", className: classnames(moduleStyles.previewSongButton, !levelIsRunning && songInPreview && moduleStyles.previewActiveButton), disabled: levelIsRunning, color: Button.ButtonColor.neutralDark, icon: " fa-solid fa-play-pause", onClick: onPreviewBtnClick })));
};
export default SongSelector;
